export enum ParticipantRole {
  Owner = 'Owner',
  Collaborator = 'Collaborator',
  Viewer = 'Viewer',
  HiddenCollaborator = 'HiddenCollaborator',
}
